module.exports = __webpack_public_path__ + "img/1.f891c586.png";